<template>
  <div class="flex items-center">
    <ul class="user-list mt-2">
      <li v-for="(user, userIndex) in users" :key="userIndex">
        <vx-tooltip :text="user.User.FullName" position="bottom">
          <vs-avatar
            :src="user.User.ProfilePicture"
            size="30px"
            class="border-2 border-white border-solid -m-1"
          ></vs-avatar>
        </vx-tooltip>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CellRendererAccounts",
  computed: {
    getValue() {
      return this.$t("TableTotalAccounts", { count: this.params.value.length });
    },
    users() {
      return this.params.value;
    }
  }
};
</script>
